export const CarrierActionTypes = {
    API_RESPONSE_SUCCESS: '@@carriers/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@carriers/API_RESPONSE_ERROR',
    READ_ALL_CARRIER_REQUEST: '@@carriers/READ_ALL_CARRIER_REQUEST',
    CREATE_CARRIER_REQUEST: '@@carriers/CREATE_CARRIER_REQUEST',
    UPDATE_CARRIER_REQUEST: '@@carriers/UPDATE_CARRIER_REQUEST',
    DELETE_CARRIER_REQUEST: '@@carriers/DELETE_CARRIER_REQUEST',
};
